import React from 'react';
import { Link } from 'react-router-dom';

// Image imports
import Ab from '../../images/product/white injera.jpg';
import Abd1 from '../../images/about/1.png';
import Abd2 from '../../images/about/4.png';
import Abd3 from '../../images/about/5.png';
import Abd4 from '../../images/about/3.png';
import sine from '../../images/about/2.png';

const About = (props) => {
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    };

    return (
        <section className={"" + props.hclass}>
            <div className="container-fluid">
                <div className="row align-items-center">
                    <div className="col-lg-4 col-md-12 col-12">
                        <div className="orico-about-wrap">
                            <div className="orico-about-img">
                                <div className="mask">
                                    <img src={Ab} alt="About us" />
                                </div>
                                <div className="orico-ab-logo">
                                    <img src={Abd1} alt="About logo" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-8 col-md-12 col-12">
                        <div className="orico-about-text-wrap">
                            <div className="orico-about-text">
                                <span>“<span>ABOUT US</span>”</span>
                                <h2>100% Pure Teff Injera & More</h2>
                                <p>
                                    We specialize in providing authentic 100% pure Teff Injera — a healthy and traditional Ethiopian flatbread.
                                    We also offer high-quality catering services for events, reliable money transfer services, fresh meat,
                                    and a wide selection of ethnic ingredients to bring your cooking to life.
                                </p>
                                <ul>
                                   
                                
                           
                                
                               
                                    <li>
                                        <i><img src={Abd2} alt="Injera Icon" /></i>
                                        Injera & Baked Goods
                                    </li>
                                    
                                    <li>
                                        <i><img src={Abd3} alt="Money Transfer Icon" /></i>
                                         money transfer.
                                    </li>
                                    <li>
                                        <i><img src={Abd2} alt="Injera Icon" /></i>
                                         Catering Services
                                    </li>
                                    <li>
                                        <i><img src={Abd2} alt="Meat & Ingredients Icon" /></i>
                                        Spices & Ingredients
                                    </li>
                                     <li>
                                        <i><img src={Abd2} alt="Injera Icon" /></i>
                                         Household Needs
                                    </li>
                                </ul>
                                <Link onClick={ClickHandler} className="theme-btn-s2" to="/about">
                                    Explore Our Services
                                </Link>
                            </div>
                            {/* <div className="ab-onion-shape">
                                <img src={Abd4} alt="Decoration" />
                            </div> */}
                        </div>
                    </div>
                </div>
            </div>
            {/* <div className="ab-shape">
                <img src={sine} alt="Shape design" />
            </div> */}
        </section>
    );
};

export default About;
